import { render, staticRenderFns } from "./KycDetailsFieldTag.vue?vue&type=template&id=4d260aa4&scoped=true&"
import script from "./KycDetailsFieldTag.vue?vue&type=script&lang=js&"
export * from "./KycDetailsFieldTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d260aa4",
  null
  
)

export default component.exports